import { useCallback } from 'react'
import { Stack, styled, Typography } from '@mui/material'
import { VideoMessage } from '@weblite/ts-action/message'
import { PlayIcon } from '$common/icons/play'
import { formatDuration } from '$func/time'
import { showMediaViewerModal } from '$comp/modals/media-viewer'
import { MediaWrapper } from '../../media-wrapper'

const Thumbnail = styled('img')`
  object-fit: cover;
`

const InfoContainer = styled(Stack)`
  height: 20px;
  flex-direction: row;
  align-items: center;
  overflow: hidden;

  padding: 0 6px;
  position: absolute;
  right: 5px;
  bottom: 5px;

  background-color: #30353acc;
  border-radius: 8px;
`

const VideoDurationTypography = styled(Typography)`
  display: inline-block;
  font-size: 10px;
  line-height: 17px;
  margin-right: 2px;
`

export function Video({
  attachment,
  selected,
  selectOnTap,
  roomId,
  iid,
}: {
  attachment: VideoMessage['attachment']
  selected: boolean
  selectOnTap: boolean
  roomId: string
  iid: number
}) {
  const { duration, base64 } = attachment
  const videoDurationText = formatDuration(duration, 's')

  const playVideo = useCallback(async () => {
    if (selectOnTap) return
    showMediaViewerModal({ roomId, iid })
  }, [selectOnTap])

  return (
    <MediaWrapper selected={selected}>
      <Thumbnail
        src={base64}
        alt="video-thumbnail"
        sx={{
          width: '100%',
          height: '100%',
          cursor: 'pointer',
          opacity: selected ? 0.4 : 1,
          transition: 'opacity 0.2s',
        }}
        onClick={playVideo}
      />

      <InfoContainer>
        <PlayIcon sx={{ width: '11px', height: '11px' }} />
        <VideoDurationTypography color="white">
          {videoDurationText}
        </VideoDurationTypography>
      </InfoContainer>
    </MediaWrapper>
  )
}
